<template>
  <v-container>
    <v-card class="px-6 pb-0 mb-3">
      <v-row>
        <v-col md="3" class="pb-0">
          <v-menu
            ref="menu"
            v-model="menu_start"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="dateFormatted(start_date)"
                label="Start Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                color="primary"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="start_date"
              @change="onStartDateChange"
              no-title
              scrollable
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3" class="pb-0">
          <v-menu
            ref="menu"
            v-model="menu_end"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="dateFormatted(end_date)"
                label="End Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                color="primary"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="end_date"
              @change="onEndDateChange"
              no-title
              scrollable
              :min="start_date"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3" class="pa-6">
          <v-btn block color="primary" @click="fetchAttendances"
            ><v-icon>mdi-magnify</v-icon>Search</v-btn
          >
        </v-col>
        <v-col md="3" class="pa-6">
          <download-excel
            :data="attendances"
            worksheet="Monthly"
            name="Activity Report.xls">
            <v-btn block outlined color="primary">
              <v-icon>mdi-download</v-icon>
              Download Report
            </v-btn>  
          </download-excel>
        </v-col>
      </v-row>
    </v-card>
    <v-card>
      <v-card-title>
        Attendance Report
        <v-row justify="end">
          <v-col md="3">
            <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Find a user"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col md="3" class="pa-6">
            <v-btn
              block
              color="primary"
              @click="exportHRIS()"
              :loading="export_button_loading"
              :disabled="export_button_loading"
            >
              HRIS Export<v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="attendances"
        :search="search"
        :sort-by="['date_in']"
        :sort-desc="[true]"
        multi-sort
        :no-data-text="$t('no_data')"
        :footer-props="{ 'items-per-page-options': [10, 50, 100] }"
      >
       <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
        <template v-slot:item.note_in="{ item }">
          <v-chip :color="getNoteColor(item.note_in)" class="caption">{{
            item.note_in
          }}</v-chip>
        </template>
        <template v-slot:item.note_out="{ item }">
          <v-chip :color="getNoteColor(item.note_out)" class="caption">{{
            item.note_out
          }}</v-chip>
        </template>
        <template v-slot:item.reason_in="{ item }">
          <v-chip :color="getReasonColor(item.reason_in)" class="caption">{{
            item.reason_in
          }}</v-chip>
        </template>
        <template v-slot:item.reason_out="{ item }">
          <v-chip :color="getReasonColor(item.reason_out)" class="caption">{{
            item.reason_out
          }}</v-chip>
        </template>
        <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
      </v-data-table>
    </v-card>
    <v-snackbar v-model="snackbar" color="success" multi-line top>
      <v-icon color="white">mdi-checkbox-marked-circle</v-icon>
      <span style="padding-left:8px">{{ snackbar_message }}</span>
      <v-btn text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="error_snackbar" color="error" multi-line top>
      <v-icon color="white">mdi-close-circle</v-icon>
      <span style="padding-left:8px">{{ error_message }}</span>
      <v-btn text @click="error_snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import axios from "axios";
import moment from "moment";
import mt from "moment-timezone";
export default {
  name: "activity-report",
  data() {
    return {
      baseUrl: this.$store.state.baseUrl,
      date: new Date().toISOString().substr(0, 10),
      menu_start: false,
      menu_end: false,
      search: "",
      headers: [
        { text: "Code", value: "employeecode" },
        { text: "Name", value: "fullname" },
        { text: "Date", value: "date_in" },
        // { text: "Excel", value: "date_excel" },
        { text: "Time In", value: "time_in" },
        { text: "Time Out", value: "time_out" },
        { text: "Duration", value: "workhour" },
        // { text: "Latitude", value: "lng_in" },
        // { text: "Longitude", value: "lng_out" },
        // { text: "Time In", value: "reason_in" },
        // { text: "Time Out", value: "reason_out" },
        // { text: "Location In", value: "note_in" },
        // { text: "Location Out", value: "note_out" }
      ],
      company_id: "trlq", // TODO: access from state
      start_date: "",
      end_date: "",
      loading: true,
      export_button_loading: false,
      snackbar: false,
      snackbar_message: "",
      error_snackbar: false,
      error_message: "",
      attendances: [],
      summary: {
        on_time: 0,
        tolerance_time: 0,
        late: 0,
        on_location: 0,
        tolerance_location: 0,
        out_of_location: 0,
      },
      hours: "",
    };
  },
  methods: {
    onStartDateChange() {
      const diff = moment(this.end_date).diff(this.start_date, 'days')
      if (diff < 0) this.end_date = this.start_date
      this.menu_start = false;
    },
    onEndDateChange() {
      this.menu_end = false;
    },
    dateFormatted(date) {
      return moment(date).format("Do MMMM YYYY");
    },
    countTimeSummary(reason) {
      if (reason === "-" || reason === null) {
        return;
      }
      if (reason === "On-Time") {
        this.summary.on_time += 1;
      } else {
        if (reason === "In-Tolerance") {
          this.summary.tolerance_time += 1;
        } else {
          this.summary.late += 1;
        }
      }
    },
    countLocationSummary(note) {
      if (note === "-" || note === null) {
        return;
      }
      if (note === "In-Area") {
        this.summary.on_location += 1;
      } else {
        if (note === "GPS Error" || note === "Meeting") {
          this.summary.tolerance_location += 1;
        } else {
          this.summary.out_of_location += 1;
        }
      }
    },
    getReasonColor(reason) {
      if (reason === "-" || reason === null) {
        return;
      }
      if (reason === "On-Time") {
        return "success";
      } else {
        if (reason === "In-Tolerance") {
          return "warning";
        } else {
          return "error";
        }
      }
    },
    getNoteColor(note) {
      if (note === "-" || note === null) {
        return;
      }
      if (note === "In-Area") {
        return "success";
      } else {
        if (note === "GPS Error" || note === "Meeting") {
          return "warning";
        } else {
          return "error";
        }
      }
    },
    convertDate(time) {
      let convert = time.toString().split(" ");
      let hour = convert[4];
      return hour;
    },
    toHours(zone, time) {
      if (time != undefined) {
        let utc = new Date(parseInt(time));
        let tmp = "";
        if (zone === 7) {
          tmp = mt.tz(utc, "Asia/Jakarta");
        } else if (zone === 8) {
          tmp = mt.tz(utc, "Asia/Makassar");
        } else if (zone === 9) {
          tmp = mt.tz(utc, "Asia/Jayapura");
        }
        return this.convertDate(tmp);
      }
    },
    resetSummary() {
      this.summary = {
        on_time: 0,
        tolerance_time: 0,
        late: 0,
        on_location: 0,
        tolerance_location: 0,
        out_of_location: 0,
      };
    },
    dateToExcelDate(date) {
      let returnDateTime =
        25569.0 +
        (date.getTime() - date.getTimezoneOffset() * 60 * 1000) /
          (1000 * 60 * 60 * 24);
      return returnDateTime.toString().substr(0, 5);
    },
    fetchAttendances() {
      let company_id = this.$store.state.company;
      let date_start = moment(this.start_date).format("DD-MM-YYYY");
      let date_end = moment(this.end_date).format("DD-MM-YYYY");
      this.resetSummary();
      const url = `${this.baseUrl}/attendance/listbycompanyid?companyId=` +
        company_id +
        "&startDate=" +
        date_start +
        "&endDate=" +
        date_end;
      axios.get(url,{ headers: { action: 'Get Attendance List', actionId: 4 } }).then((res) => {
        // this.attendances = res.data.data;
        this.attendances = [];
        res.data.data.forEach((row) => {
          let attendance = {};
          attendance.employeecode = row.employeecode;
          attendance.fullname = row.full_name;
          // attendance.email = row.email
          attendance.date_in = moment(row.time_in, "x").format("DD-MM-YYYY");
          attendance.date_excel = this.dateToExcelDate(
            moment(row.time_in, "x").toDate()
          );
          attendance.time_in = this.toHours(row.group_timezone, row.time_in);
          attendance.time_out = this.toHours(row.group_timezone, row.time_out);
          attendance.workhour = row.workhour;
          // attendance.note_in = row.note_in
          // attendance.note_out = row.note_out
          // attendance.reason_in = row.reason_in
          // attendance.reason_out = row.reason_out
          // this.countTimeSummary(row.reason_in);
          // this.countTimeSummary(row.reason_out);
          // this.countLocationSummary(row.note_in);
          // this.countLocationSummary(row.note_out);
          this.attendances.push(attendance);
        });
        this.loading = false;
      });
    },
    exportHRIS() {
      this.export_button_loading = true;
      const start = moment(this.start_date);
      const end = moment(this.end_date);
      const duration = moment.duration(end.diff(start));
      if (duration.asDays() > 1) {
        this.error_message =
          "Date range is above 1 days: Unable to send more than 1 days of data, please adjust your dates and try again";
        this.error_snackbar = true;
        this.export_button_loading = false;
      } else {
        const date_start = start.format("DD-MM-YYYY");
        const date_end = end.format("DD-MM-YYYY");
        const url = `https://us-central1-appsensi-dev.cloudfunctions.net/sendAttendancesBhinneka?date_start=${date_start}&date_end=${date_end}`;
        axios
          .get(url, {timeout: 300000})
          .then(() => {
            this.snackbar_message = "Data Sent Successfully";
            this.snackbar = true;
            this.export_button_loading = false;
          })
          .catch((err) => {
            this.error_message = "Data could not be sent";
            this.error_snackbar = true;
            // eslint-disable-next-line no-console
            console.error(err);
            this.export_button_loading = false;
          });
      }
    },
  },
  created() {
    this.start_date = moment()
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    this.end_date = moment().format("YYYY-MM-DD");
    this.fetchAttendances();
  },
};
</script>
